module.exports = __webpack_public_path__ + "img/lazy-img.a12600ab.png";